/* eslint-disable i18next/no-literal-string  -- .*/
import { CommissionsTableWithData } from '@/affiliate-dashboard/components/commissions/tables-with-data';
import {
  useImpersonateMutation,
  type UserFragment,
} from '@/affiliate-dashboard/graphql';
import { Button } from '@/components/base/button';
import Section from '@/components/base/section';
import { CredentialsContext } from '@/context/credentials-context';
import {
  faCalendar,
  faEarth,
  faEnvelope,
} from '@fortawesome/pro-regular-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { format } from 'date-fns';
import { useContext } from 'react';
import { useCookies } from 'react-cookie';
import { ReactCountryFlag } from 'react-country-flag';

export function Overview({ data }: { data: UserFragment }): JSX.Element {
  const {
    firstName,
    lastName,
    email,
    createdAt,
    countryName,
    countryCode,
    userNumber,
  } = data ?? {};

  const [_cookie, setCookie] = useCookies(['ADMIN_TOKEN']);
  const { setToken, token } = useContext(CredentialsContext);
  const [impersonateMutation, { loading }] = useImpersonateMutation();

  async function impersonate(): Promise<void> {
    setCookie('ADMIN_TOKEN', token, { path: '/' });
    const { data: impersonateData } = await impersonateMutation({
      variables: {
        userNumber,
      },
    });

    if (impersonateData?.impersonate?.accessToken) {
      setToken(impersonateData?.impersonate.accessToken);
      location.reload();
    }
  }

  return (
    <Section variant="secondary">
      <div className="flex flex-col gap-5">
        <div className="flex flex-col gap-5 md:flex-row md:gap-10">
          <div>
            <div className="flex flex-col gap-1">
              <div className="flex items-start justify-between gap-2">
                <span>
                  {firstName} {lastName}
                </span>
                <Button
                  loading={loading}
                  onClick={() => impersonate()}
                  variant="outlined"
                  className="px-2 py-1 text-xs"
                >
                  Impersonate
                </Button>
              </div>

              <div className="flex items-center gap-2 text-sm text-default-gray-500">
                <FontAwesomeIcon className="h-4 w-4" icon={faEnvelope} />
                <span>{email}</span>
              </div>

              <div className="flex items-center gap-2 text-sm text-default-gray-500">
                <FontAwesomeIcon className="h-4 w-4" icon={faCalendar} />
                <span>
                  Joined on{' '}
                  <span>{format(createdAt ?? '', 'dd MMM yyyy')}</span>
                </span>
              </div>

              <div className="flex items-center gap-2 text-sm text-default-gray-500">
                {countryCode ? (
                  <ReactCountryFlag
                    countryCode={countryCode}
                    style={{
                      height: '1.1rem',
                      width: '1.1rem',
                      borderRadius: '100%',
                      objectFit: 'cover',
                    }}
                    svg
                  />
                ) : (
                  <FontAwesomeIcon className="h-4 w-4" icon={faEarth} />
                )}
                <span>{countryName}</span>
              </div>
            </div>
          </div>

          <div className="flex flex-col gap-1">
            <div className="flex items-center gap-2">
              <span>Payout Details</span>
            </div>

            {/* <div className="flex items-center gap-2 text-sm text-default-gray-500">
            <span>{targetAddress}</span>
          </div> */}

            {/* <div className="flex items-center gap-2 text-sm text-default-gray-500">
            {network ? (
              <div>
                {cloneElement(cryptoDataMap[network as Crypto].icon, {
                  width: 20,
                  height: 20,
                })}
              </div>
            ) : (
              <RiseNoLabel />
            )}
            <span>{paymentMethodMetadata}</span>
          </div> */}
          </div>
        </div>

        <CommissionsTableWithData userNumber={userNumber} />
      </div>
    </Section>
  );
}
